<template functional>
  <b v-if="bold">₽</b><span v-else>₽</span>
</template>

<script>
  export default {
    name: 'Rub',
    props: {
      bold: {
        type: Boolean,
        default: false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Rub.vue